import React from 'react'
import newsletterConfig from '../../../newsletter-config.json'
import { NewsletterSectionRow, TableWrapper } from "./helpersComponents"
import NewsletterContentText from "./NewsletterContentText"
import { textNormal } from './helpersTypo'

const NewsletterSectionAddress = ({stylesData, cinemaData}) => {
    if(!stylesData || !cinemaData || !cinemaData.cinemaAddress) {
        return  null
    }

    const filteredData = Object.keys(cinemaData.cinemaAddress).filter(key => newsletterConfig.addressStructure.includes(key) && cinemaData.cinemaAddress[key])
    const filteredDataLength = filteredData.length

    if(0 === filteredDataLength) {
        return null
    }

    const chosenFont = stylesData.chosenFont
    const colorText = stylesData.secText

    return (
        <NewsletterSectionRow>
            <TableWrapper>
                <tr>
                    <NewsletterContentText>
                        <p style={{...{color: colorText, margin: 0, textAlign: 'center'}, ...textNormal(chosenFont)}}>
                            {cinemaData.cinemaName && <span>{cinemaData.cinemaName},  </span>}

                            {filteredData.map((key, index) => (
                                <span key={key}>
                                    {cinemaData.cinemaAddress[key]} 
                                    {index + 1 < filteredDataLength ? ',  ' : null}
                                </span>
                            ))}
                        </p>
                    </NewsletterContentText>
                </tr>
            </TableWrapper>
        </NewsletterSectionRow>
    )
}

export default NewsletterSectionAddress